import "./Spinner.scss";

const Spinner = () => {
  return <span className="berg-components-spinner"></span>;
};

export default Spinner;
